import React from 'react';
import ReactLoading from "react-loading";
import './loadingCard.scss';

const LoadingCard = ({ copy }) => {
    return (
        <div className='load'>
            <h1 className='loading header'>{copy}</h1>
            <ReactLoading className='spinner-icon' type={"spin"} color={"gray"} height={'50px'} width={'50px'} />
        </div>
    );
};

export default LoadingCard;